// extracted by mini-css-extract-plugin
module.exports = {"tools":"footer_tools__zawca","brand":"footer_brand__6BBfU","btns":"footer_btns__xblaU"};